import type { AvatarRendererPort } from './ports';
import { NotImplementedAvatarRenderer } from './adapters';

let avatarRendererInstance: AvatarRendererPort | null = null;

/**
 * Composition root for avatar-integration. Swap `NotImplementedAvatarRenderer`
 * for a real Unity-backed adapter here when that work begins — every
 * consumer (store, widgets) depends only on `AvatarRendererPort`.
 */
export function getAvatarRenderer(): AvatarRendererPort {
  if (!avatarRendererInstance) {
    avatarRendererInstance = new NotImplementedAvatarRenderer();
  }
  return avatarRendererInstance;
}
